<template lang="pug">
  .perfis-aprovadores
    div(v-if="valueInterno.length === 0")
      | Não possuem perfis cadastrados válidos
    TransitionExpand(v-else)
      template(v-for="(item, indice) in valueInterno")
        .perfis-aprovadores__item(:key="indice")
          .perfis-aprovadores__seletor
            PSelect(
              v-model="item.id"
              :options="listaPerfisInternaComPerfilSelecionado(item)"
              :allowEmpty="false"
              labelItem="name"
              title="perfil"
              name="perfil"
              :disabled="desativado"
            )
          .perfis-aprovadores__limitador
            .perfis-aprovadores__limitador-checkbox
              PCheckbox(
                v-model="item.marcado"
                label="limitar respostas por cada usuário desse perfil por quantidade (ao mês)"
                :v-mask="'#####'"
                :disabled="desativado"
                @change="novoValor => resetaQuantidadeLimite(novoValor, indice)"
              )
            .perfis-aprovadores__limitador-input
              Validate(
                v-model.number="item.quantidadeLimite"
                :minLength="1"
                onlyNumbers
              )
                PTextField(
                  label="quant. limite"
                  :disabled="desativado || !item.marcado"
                )
            .perfis-aprovadores__limitador-informativo(v-if="indice === 0")
              p &nbsp
                span.direita.icon-ptt-icons-info.color-info.fs-15(:title="mensagemInformativa")
          .perfis-aprovadores__acoes
            .botao.deletar(v-if="valueInterno.length > 1")
              PButton(
                size="sm"
                color="danger"
                @click="removerPerfil(indice)"
                :disabled="desativado"
              )
                span.icon-ptt-icons-excluir
            .botao.adicionar(v-if="(indice + 1) === valueInterno.length")
              PButton(
                @click="adicionarPerfil"
                :disabled="desativado || !primeiroPerfilValido"
                color="warning"
                size="sm"
              ) adicionar perfil
</template>

<script>
export default {
  name: 'PerfisAprovadoresNovo',
  props: {
    desativado: {type: Boolean, required: false},
    value: {type: Array, required: true},
    listaPerfis: {type: Array, required: true},
    unico: {type: Boolean, required: false},
    filtros: {
      type: Array,
      required: false,
      validator (itens) {
        const todosOsFiltrosSaoUmaFuncao = itens.every(item => typeof item === 'function')
        return todosOsFiltrosSaoUmaFuncao
      },
      default: () => []
    }
  },
  data () {
    return {
      mensagemInformativa: 'O limite é a quantidade máxima de pedidos que cada usuário cadastrado com um perfil poderá responder, no período de um mês, contando a partir do dia definido na regra. Ex: para um perfil que possui 5 usuários e limite de 10 respostas a partir do dia 20 do mês, cada usuário poderá responder até 10 pedidos, totalizando, entre o dia 20 de um mês até 20 do mês seguinte, um máximo de 50 respostas desse perfil. Os pedidos que excederem o limite deverão ser respondidos pelo perfil de RH.',
      valueInterno: []
    }
  },
  watch: {
    valueInterno: {
      immediate: false,
      deep: true,
      handler (valor) {
        this.atualizarValorComValorInterno(valor)
      }
    }
  },
  computed: {
    primeiroPerfilValido () {
      /**
       * usado na inicialização do valor interno para exibir um primeiro item
       * e sempre que o usuário clicar em "adicionar perfil"
       */
      const {listaPerfisInterna} = this
      if (listaPerfisInterna.length) {
        const [primeiroPerfil] = listaPerfisInterna
        return {
          id: primeiroPerfil.id,
          marcado: false,
          quantidadeLimite: 1
        }
      } else {
        return null
      }
    },
    listaPerfisInterna () {
      /**
       * lista de perfis para ser usada no componente após receber todos os filtros
       */
      const {filtros, filtrosInternos, listaPerfis} = this
      const todosOsFitros = [...filtros, ...filtrosInternos]
      const listaPerfisFiltrada = todosOsFitros.reduce((lista, filtro) => {
        return lista.filter(filtro)
      }, [...listaPerfis])
      return listaPerfisFiltrada
    },
    filtrosInternos () {
      /**
       * filtros pré-definidos para os itens elegíveis de acordo com propriedades ativadas no componente
       * para registrar esses filtros adicione uma prop boleana no componente e mapeie uma função nos 'filtrosPreDefinidos'
       */
      const {valueInterno} = this

      const filtrosPreDefinidos = {
        unico: perfil => !valueInterno.find(item => item.id === perfil.id)
      }

      const filtrosInternos = Object.entries(filtrosPreDefinidos).reduce((filtrosAtivados, [propriedade, funcaoFiltro]) => {
        const filtroAtivado = !!this[propriedade]
        if (filtroAtivado) {
          filtrosAtivados.push(funcaoFiltro)
        }
        return filtrosAtivados
      }, [])

      return filtrosInternos
    },
    todosOsAprovadoresSaoValidos () {
      // Checagem para ser usada em ApprovalsRulesDetails.vue antes de salvar
      const {valueInterno} = this

      function aprovadorEhValido (aprovador) {
        if (!aprovador.marcado) return true
        return Number.isFinite(aprovador.quantidadeLimite) && aprovador.quantidadeLimite > 0
      }

      return valueInterno
        .map(aprovadorEhValido)
        .every(ehValido => ehValido === true)
    }
  },
  created () {
    this.inicializarValueInterno()
  },
  methods: {
    converterPerfilParaPadraoInterno (perfil) {
      return {
        id: perfil.id_perfil,
        marcado: perfil.limite_aprovacoes_mensal_por_perfil > 0,
        quantidadeLimite: perfil.limite_aprovacoes_mensal_por_perfil
      }
    },
    inicializarValueInterno () {
      /**
       * inicializa o valor interno
       * se for uma edição haverá um valor setado externamente
       * se for uma criação precisa inicializar com um perfil válido
       */
      const {primeiroPerfilValido, value, converterPerfilParaPadraoInterno} = this

      const possuiValorSetadoExternamente = !!value.length
      if (possuiValorSetadoExternamente) {
        this.valueInterno = value.map(converterPerfilParaPadraoInterno)
      } else {
        this.valueInterno = primeiroPerfilValido ? [primeiroPerfilValido] : []
      }
    },
    adicionarPerfil () {
      /**
       * concatena o primeiro perfil válido na lista do valor interno
       * o botão de "adicionar perfil" deverá estar desabilitado se não houver o perfil válido
       */
      const {primeiroPerfilValido, valueInterno} = this
      if (primeiroPerfilValido) {
        this.valueInterno = [...valueInterno, {...primeiroPerfilValido}]
      }
    },
    removerPerfil (indiceClicado) {
      /**
       * remove do valor interno o item que foi excluído ao clicar no botão deletar
       */
      this.valueInterno = [...this.valueInterno.filter((item, itemIndice) => itemIndice !== indiceClicado)]
    },
    atualizarValorComValorInterno (valorInterno) {
      /**
       * realiza a conversão e emissão do valor interno para o valor esperado pelo componente pai no formato da API
       */
      const aprovadoresFormatados = valorInterno.map(perfil => {
        const validarERetornarOLimiteValido = perfil => {
          const LIMITE_INFINITO = 0
          const {marcado, quantidadeLimite} = perfil
          const limiteDefinido = quantidadeLimite !== ''
          if (marcado && limiteDefinido) {
            return Number.parseInt(quantidadeLimite)
          }
          return LIMITE_INFINITO
        }

        const limiteDoPerfil = validarERetornarOLimiteValido(perfil)
        return {
          id_perfil: perfil.id,
          limite_aprovacoes_mensal_por_perfil: limiteDoPerfil
        }
      })
      this.$emit('input', aprovadoresFormatados)
    },
    listaPerfisInternaComPerfilSelecionado (perfilSelecionado) {
      /**
       * realiza a concatenação da lista de perfis interna filtrada com o próprio item perfil selecionado
       * é importante, pois permite que os detalhes sejam exibidos
       * já que a lista foi filtrada para evitar duplicidade e as informações do item não estão presentes
       */
      const {listaPerfis, listaPerfisInterna} = this
      const perfil = listaPerfis.find(perfil => perfil.id === perfilSelecionado.id)
      return [...listaPerfisInterna, perfil]
    },
    resetaQuantidadeLimite (novoValor, indice) {
      if (typeof novoValor === 'boolean' && !novoValor) {
        this.valueInterno[indice].quantidadeLimite = 1
      }
    }
  }
}
</script>

<style scoped lang="scss">
  * {
    box-sizing: border-box;
  }
  .perfis-aprovadores, .perfis-aprovadores span:first-child {
    width: 100%
  }

  .perfis-aprovadores__item {
    display: grid;
    grid-template-columns: 40% 40% 20%;
    grid-template-rows: auto;
    grid-template-areas: "seletor limitador acoes";
    grid-gap: 1rem;
    align-items: center;
    justify-content: flex-start;
  }

  .perfis-aprovadores__seletor {
    grid-area: seletor;
  }

  .perfis-aprovadores__limitador {
    width: auto;
    grid-area: limitador;
    display: grid;
    grid-template-columns: 70% 20% 10%;
    grid-template-rows: auto;
    grid-template-areas: "checkbox input informativo";
    grid-gap: 1rem;
    align-items: center;
    justify-content: flex-start;
    &-checkbox {
      grid-area: checkbox;
    }
    &-input {
      grid-area: input;
    }
    &-informativo {
      grid-area: informativo;
    }
  }

  .perfis-aprovadores__acoes {
    grid-area: acoes;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto;
    grid-template-areas: "deletar adicionar";

    .botao {
      align-self: center;
      justify-self: flex-end;
    }

    .adicionar {
      width: 180px;
      margin-left: 1px;
      grid-area: adicionar;
    }

    .deletar {
      align-self: center;
      grid-area: deletar;
    }
  }
</style>
